import { CurrencyDropdown } from 'domain/shared/core/input';
import {
  BaseAmountTypeDropdown,
  EmployeeContractTypeDropdown,
  OfficeDropdown,
  ProbationPeriodReductionInput,
} from 'domain/shared/employee';
import { EnumDropdown, TextInput } from 'framework/form';
import { CreateEditFormDrawer } from 'framework/ViewTypes/contentLayout';
import type { CreateEditFormSection } from 'framework/ViewTypes/contentLayout';
import applicationCreateOfferValidation from '../validation/applicationCreateOfferValidation';

type ApplicationCreateOfferDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
};

const POSITION_FILL_REQUESTS = {
  DAVINCI_PROJECT: 'Davinci project',
  DOTNET_ENGINEERS: '.NET engineers',
};

const CREATE_OFFER_SECTIONS: CreateEditFormSection[] = [
  {
    id: 'amount',
    fields: [
      {
        id: 'baseAmountType',
        content: <BaseAmountTypeDropdown source="baseAmountType" label="Base amount type" isRequired />,
      },
      {
        id: 'currency',
        content: <CurrencyDropdown source="currency" label="Currency" isRequired />,
      },
      {
        id: 'finalAmountGross',
        content: <TextInput source="finalAmountGross" label="Final amount gross" isRequired />,
      },
    ],
  },
  {
    id: 'probation',
    fields: [
      {
        id: 'probationAmountGross',
        content: <TextInput source="probationAmountGross" label="Probation amount gross" isRequired />,
      },
      {
        id: 'probationPeriodReduction',
        content: (
          <ProbationPeriodReductionInput
            source="probationPeriodReduction"
            probationAmountSource="probationAmountGross"
            baseAmountSource="finalAmountGross"
            label="Probation period reduction, %"
            saveToContext
          />
        ),
      },
    ],
  },
  {
    id: 'employment',
    fields: [
      {
        id: 'office',
        content: <OfficeDropdown source="office" label="Office" isRequired />,
      },
      {
        id: 'contractType',
        content: <EmployeeContractTypeDropdown source="contractType" label="Contract type" isRequired />,
      },
    ],
  },
  {
    id: 'positionFillRequest',
    fields: [
      {
        id: 'positionFillRequest',
        size: { xs: 12, md: 8, xl: 8 },
        content: (
          <EnumDropdown
            source="positionFillRequest"
            label="Position fill request"
            placeholder="Select position fill request"
            options={POSITION_FILL_REQUESTS}
            isRequired
          />
        ),
      },
    ],
  },
];

const ApplicationCreateOfferDrawer = ({ isOpen, onClose }: ApplicationCreateOfferDrawerProps) => (
  <CreateEditFormDrawer
    isOpen={isOpen}
    onClose={onClose}
    title="Create offer"
    isCreateRequest
    getValidationSchemaFunc={() => Promise.resolve(applicationCreateOfferValidation)}
    submitFormFunc={async () => {}}
    afterSubmit={{ execute: onClose, message: 'Offer created.' }}
    submitButtonTitle="Create"
    handleDirty={false}
    getSections={() => CREATE_OFFER_SECTIONS}
  />
);

export default ApplicationCreateOfferDrawer;
